import React from 'react';
import { modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-177" data-mp="100c9f2m1l0zr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-178" data-mp="zy97plbj1jf7">
        <header className="mx-auto max-w-4xl text-center" data-id="element-179" data-mp="l4mrpgnw3a0u">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-180" data-mp="q264ec4xveqo">
            Sistema Completo:
            <br data-id="element-181" data-mp="1dtbjuq6yw50g" />
            <span className="text-blue-600" data-id="element-182" data-mp="1dssdm6qoj529">6 Tomos Visuales</span>
          </h2>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-183" data-mp="1iqbrv6ndnhu7">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-184" data-mp="1404gtbzp913j">
              <div className="flex items-baseline gap-3" data-id="element-185" data-mp="1wq34b2y8wq63">
                <span className="text-sm font-extrabold uppercase tracking-[0.12em] text-teal-900/80" data-id="element-186" data-mp="21hbe403hmdjs">
                  {module.unit}
                </span>
                <span className="text-5xl font-extrabold leading-none tracking-tight text-teal-900" data-id="element-187" data-mp="2vg3nllo8uyll">
                  {module.count}
                </span>
              </div>
              <h3 className="mt-4 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-188" data-mp="356f2u4ddou7s">
                {module.title}
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-189" data-mp="30d2ezwgiwrg3">{module.summary}</p>
              <p className="mt-auto pt-4 font-semibold text-blue-700" data-id="element-190" data-mp="3e4qt25ac1pzp">{module.closing}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}